export default __webpack_public_path__ + "static/shopping_background-093f216a5ee67619e9c875383f3e0932.png";